import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

import { TranslocoPipe } from '@jsverse/transloco';
import { NzRadioModule } from 'ng-zorro-antd/radio';

import { UiIconsList, UiIconsModule } from 'ui-icons';

type Value = unknown;

export interface RadioOption {
  value: string | number | boolean;
  label: string;
  icon?: UiIconsList;
  disabled?: boolean;
}

@Component({
  selector: 'ui-platform-radio',
  templateUrl: './radio.component.html',
  styleUrl: './radio.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    NzRadioModule,
    TranslocoPipe,
    UiIconsModule
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiPlatformRadioComponent),
      multi: true
    }
  ]
})
export class UiPlatformRadioComponent implements ControlValueAccessor {
  @Input() options: RadioOption[] = [];
  @Input() label = '';
  @Input() asButtonGroup = false;

  disabled = false;
  internalValue: Value = null;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  syncExternalValue: (value: Value) => void = () => {};
  syncExternalTouched: () => void = () => {};

  onModelChange(value: Value) {
    this.syncExternalValue(value);
    this.syncExternalTouched();
  }

  writeValue(value: Value) {
    this.internalValue = value;
    this.changeDetectorRef.detectChanges();
  }

  registerOnChange(fn: (value: Value) => void) {
    this.syncExternalValue = (value: Value) => {
      fn(value);
    };
  }

  registerOnTouched(fn: () => void) {
    this.syncExternalTouched = () => {
      fn();
    };
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
    this.changeDetectorRef.detectChanges();
  }
}
